/* eslint-disable @typescript-eslint/no-unused-vars */
import { configureStore } from '@reduxjs/toolkit';
import {
  useStore as reduxStore,
  useDispatch as reduxDispatch,
  useSelector as reduxSelector,
} from 'react-redux';

import userSlice from './userSlice';
import toastsSlice from './toastSlice';
// Customer
import customerModalSlice from './customerModalSlice';
import customerPopupModalSlice from './customerPopupModalSlice';
import customerTermsModalSlice from './customerTermsModalSlice';
import customerBrowseSlice from './customerBrowseSlice';
import customerSearchModalSlice from './customerSearchModalSlice';
// Vendor
import vendorModalSlice from './vendorModalSlice';
import vendorPopupModalSlice from './vendorPopupModalSlice';
import vendorTermsModalSlice from './vendorTermsModalSlice';
import vendorBrowseSlice from './vendorBrowseSlice';
import vendorSearchModalSlice from './vendorSearchModalSlice';
// Item
import itemBrowseSlice from './itemBrowseSlice';
import itemPopupModalState from './itemPopupModalSlice';
import itemModalSlice from './itemModalSlice';
import itemSearchModalSlice from './itemSearchModalSlice';
// Order
import orderModalSlice from './orderModalSlice';
import orderBrowseSlice from './orderBrowseSlice';
import orderPopupModalSlice from './orderPopupModalSlice';
import orderSearchModalSlice from './orderSearchModalSlice';
// Purchase Order
import purchaseOrderBrowseSlice from './purchaseOrderBrowseSlice';
import purchaseOrderModalSlice from './purchaseOrderModalSlice';
import purchaseOrderPopupModalSlice from './purchaseOrderPopupModalSlice';
import purchaseOrderSearchModalSlice from './purchaseOrderSearchModalSlice';
// Invoice
import invoiceModalSlice from './invoiceModalSlice';
import invoiceBrowseSlice from './invoiceBrowseSlice';
import invoicePopupModalSlice from './invoicePopupModalSlice';
// ShipMethods
import altShipMethodsModalSlice from './altShipMethodsModalSlice';
import shipMethodsModalSlice from './shipMethodsModalSlice';
import systemNumbersModalSlice from './systemNumbersModalSlice';
import settingsModalSlice from './settingsModalSlice';
import salesTaxSearchModalSlice from './salesTaxSearchModalSlice';
// Account
import accountModalSlice from './accountModalSlice';
// Audit History
import auditHistoryModalSlice from './auditHistoryModalSlice';
// Packing Slip
import packingSlipBrowseSlice from './packingSlipBrowseSlice';
import packingSlipPopupModalSlice from './packingSlipPopupModalSlice';
import packingSlipModalSlice from './packingSlipModalSlice';

export const store = configureStore({
  reducer: {
    userSlice,
    toastsSlice,
    customerModalSlice,
    customerPopupModalSlice,
    customerTermsModalSlice,
    customerBrowseSlice,
    customerSearchModalSlice,
    vendorModalSlice,
    vendorPopupModalSlice,
    vendorTermsModalSlice,
    vendorBrowseSlice,
    vendorSearchModalSlice,
    altShipMethodsModalSlice,
    shipMethodsModalSlice,
    systemNumbersModalSlice,
    settingsModalSlice,
    salesTaxSearchModalSlice,
    itemBrowseSlice,
    itemPopupModalState,
    itemModalSlice,
    itemSearchModalSlice,
    orderModalSlice,
    orderBrowseSlice,
    orderPopupModalSlice,
    orderSearchModalSlice,
    packingSlipBrowseSlice,
    packingSlipPopupModalSlice,
    packingSlipModalSlice,
    purchaseOrderBrowseSlice,
    purchaseOrderModalSlice,
    purchaseOrderPopupModalSlice,
    purchaseOrderSearchModalSlice,
    invoiceModalSlice,
    invoiceBrowseSlice,
    invoicePopupModalSlice,
    accountModalSlice,
    auditHistoryModalSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Infer the type of makeStore
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<(typeof store)['getState']>;
export type AppDispatch = (typeof store)['dispatch'];

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useDispatch = reduxDispatch.withTypes<AppDispatch>();
export const useSelector = reduxSelector.withTypes<RootState>();
